export const SET_RECENT_NOTIFICATIONS_COUNT = 'SET_RECENT_NOTIFICATIONS_COUNT';
export const GET_RECENT_NOTIFICATIONS = 'GET_RECENT_NOTIFICATIONS';
export const GET_RECENT_ORG_NOTIFICATIONS = 'GET_RECENT_ORG_NOTIFICATIONS';
export const SET_RECENT_NOTIFICATIONS = 'SET_RECENT_NOTIFICATIONS';
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS';
export const ADD_NOTIFICATIONS = 'ADD_NOTIFICATIONS';
export const SET_NOTIFICATIONS_HAS_MORE = 'SET_NOTIFICATIONS_HAS_MORE';